import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import ButtonsModal from '../../../../Elements/modal/ButtonsModal'
import { setRestaurantOrderChangeModal, setRestaurantShowOrderCancelModal } from '../../../../../redux/action/restaurant'
import { setRestaurantOrderStatusThunk } from '../../../../../redux/thunk/restaurant/orders'
import { setCancelReasonOptions } from '../../../../../redux/reducer/all-order/constants'

const EVENT_Z_INDEX = 119

const OrderCancelModal = React.memo(({ isOpen, close, order, accessToken }) => {
	const { t } = useTranslation()
	const cancelReasons = setCancelReasonOptions()
	const dispatch = useDispatch()

	const handleBack = useCallback(() => {
		dispatch(setRestaurantShowOrderCancelModal(false))
		dispatch(setRestaurantOrderChangeModal(true))
	}, [dispatch])

	const handleReasonClick = useCallback(async (event, reason) => {
		if (event) event.preventDefault()
		await dispatch(setRestaurantOrderStatusThunk(order?.orderId, 'CANCELED', reason, accessToken))
		close()
	}, [dispatch, order, close, accessToken])

	const buttons = cancelReasons?.map(option =>
		({ icon: 'cancel', text: t(option.label), onClick: e => handleReasonClick(e, option.value), show: true }))

	return (
		<ButtonsModal isOpen={isOpen}
									close={handleBack}
									id="restaurant-order-cancel-modal"
									title={t('order.modal.want_cancel_order')}
									zIndex={EVENT_Z_INDEX}
									buttons={buttons} />
	)
})

OrderCancelModal.displayName = 'OrderCancelModal'
export default OrderCancelModal
